import styled from 'styled-components'

export const MultipickFiltersTitle = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  font-weight: bold;
  margin-bottom: 10px;
`
